import { atom } from '@reatom/framework'

import { StatisticsTab } from '../model/statistics-tabs'

export const statisticsTabAtom = atom<StatisticsTab>(
  StatisticsTab.Holdings,
  'statisticsTabAtom',
)
